import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/auth';

function MenuComprasyAlmacen(props) {

    const { user, logout } = useContext(AuthContext);
    const pathname = window.location.pathname;

    const path = pathname === '/' ? 'login' : pathname.substr(1);
    const [activeItem, setActiveItem] = useState(path);
    const [permisos, setPermisos] = useState('');
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrar6, setMostrar6] = useState(false);
    const [mostrar7, setMostrar7] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [titulo2, setTitulo2] = useState();
    const [tipoRep, setTipoRep] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));


    let op = require('../../../src/modulos/datos');

    useEffect(() => {

        setPermisos(JSON.parse(localStorage.getItem('permisos')));
        let obj = JSON.parse(localStorage.getItem('post'));
        setIdUsuario(obj.idusuario);
        //setEspiritu(obj.espiritu);
        /*setLiquidador(obj.liquidador);
        setLiquida(obj.liquida);*/
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);

    }, [props.permisos]);


    const handleItemClick = (e, { name }) => setActiveItem(name);

    const imprimirListadoAgente = () => {
        window.location.href = '/comprasyAlmacen';
        var reporte = 'ListGenComercioAgente';
        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const imprimirListadoCredito = () => {
        window.location.href = '/comprasyAlmacen';
        var reporte = 'ListGenComercioCredito';
        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const handleCancelaImpSector = () => {
        window.location.href = '/comprasyAlmacen';
        setMostrar3(false);

    }

    const handleCancelaImpPatente = () => {
        //window.location.href = '/actividadEconomica';
        setMostrar6(false);

    }

    const handleCancelaImpSector2 = () => {
        window.location.href = '/comprasyAlmacen';
        setMostrar4(false);

    }

    const handleCancelaDeudav = () => {
        window.location.href = '/comprasyAlmacen';
        setMostrar5(false);

    }

    const handleCancelaRenovacionLic = () => {
        window.location.href = '/comprasyAlmacen';
        setMostrar5(false);

    }

    const handleCancelaSolicitudLic = () => {
        window.location.href = '/comprasyAlmacen';
        setMostrar6(false);

    }

    const handleImpSector = (tiprep) => (event) => {
        setTipoRep(tiprep)
        if (tiprep === '#') {
            setTitulo1(<p style={{ fontFamily: 'Times New Roman, Times, serif' }}>Impresión General de Contribuyentes por Tipo</p>);
            setTitulo2(<p style={{ fontFamily: 'Times New Roman, Times, serif' }}>Listado General de Contribuyentes por Tipo</p>);
        }
        setMostrar3(true)
    }

    const handleImpSector2 = (tiprep) => (event) => {
        setTipoRep(tiprep)
        if (tiprep === '#') {
            setTitulo1(<p style={{ fontFamily: 'Times New Roman, Times, serif' }}>Impresión General de Contribuyentes con Deuda</p>);
            setTitulo2(<p style={{ fontFamily: 'Times New Roman, Times, serif' }}>Listado General de Contribuyentes con Deuda</p>);
        }
        setMostrar4(true)
    }

    const handleImpSectorConsul = (tiprep) => (event) => {
        setTipoRep(tiprep)
        if (tiprep === '#') {
            /* setTitulo1('Impresión General de Contribuyentes con Deuda');
            setTitulo2('Listado General de Contribuyentes con Deuda'); */
        }
        setMostrar5(true)
    }

    const handleImpPatente = () => (event) => {
        setMostrar7(true)
    }

    const handleRenovacionLic = () => {
        setMostrar5(true)
    }

    const handleSolicitudLic = () => {
        setMostrar6(true)
    }

    const abrirConfiModulo = () => {
        setMostrar7(true)
    }

    const handleCancelaConfi = () => {
        setMostrar7(false)
    }

    const menu = '' /*user ? (
         <Menu inverted style={{
            height: "100%",
            backgroundColor: "#6a737b",
            color: "#fff",
            margin: 0,
            borderRadius: 0
        }} color="teal" >
          
            <Menu.Item
                name='Compras y Almacen'
                active={activeItem === 'comprasyAlmacen'}
                onClick={handleItemClick}
                as={Link}
                to="/comprasyAlmacen"
                style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}
            ></Menu.Item>
            <Dropdown item text='Almacén' style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                <Dropdown.Menu>

                    {parseInt(permisos && permisos.accvehiculo) !== 0 ?
                        <Dropdown.Item icon='edit' text='Modulo de Almacén'
                            as={Link}
                            to="#"
                            style={{ color: "#fff" }}

                        />
                        : ''}
                </Dropdown.Menu>
            </Dropdown>
            <Dropdown item text='Compras' style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                <Dropdown.Menu>

                    {parseInt(permisos && permisos.accvehiculo) !== 0 ?
                        <Dropdown.Item icon='registered' text='Registro de Proveedores'
                            as={Link}
                            to="/proveedores"
                            style={{ color: "#fff" }}

                        />
                        : ''}

                    <Dropdown.Item icon='registered' text='Registro de Unidades de Medida'
                        as={Link}
                        to="/unidadMedidas"
                        style={{ color: "#fff" }}
                    />

                    <Dropdown.Item icon='registered' text='Registro de Tipos de Productos'
                        as={Link}
                        to="/tipoProducto"
                        style={{ color: "#fff" }}
                    />

                    <Dropdown.Item icon='registered' text='Registro de Productos/Servicios'
                        as={Link}
                        to="/productos"
                        style={{ color: "#fff" }}
                    />

                    <Dropdown.Item icon='fas fa-share' text='Requisición'
                        as={Link}
                        to="#"
                        style={{ color: "#fff" }}
                    />

                    <Dropdown.Item icon='fas fa-share' text='Solicitud de Compras/Servicios'
                        as={Link}
                        to="/ordenCompra"
                        style={{ color: "#fff" }}
                    />

                    <Dropdown item icon='fas fa-check' text='Aprobaciones' style={{ color: "#000" }}>
                        <Dropdown.Menu>
                            <Dropdown.Item icon='fas fa-arrow-alt-circle-down' text='Aprobar Solicitud de Compras' as={Link}
                                to="#" />
                            <Dropdown.Item icon='fas fa-arrow-alt-circle-down' text='Aprobar Presupuesto Base' as={Link}
                                to="#" />
                            <Dropdown.Item icon='fad fa-arrow-alt-circle-left' text='Desaprobar Precompromiso' as={Link}
                                to="#" />
                            <Dropdown.Item icon='fas fa-arrow-alt-circle-down' text='Aprobar Orden de Compra' as={Link}
                                to="#" />
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown.Item icon='fas fa-file-powerpoint' text='Presupuesto Base'
                        as={Link}
                        to="#"
                        style={{ color: "#fff" }}
                    />
                </Dropdown.Menu>
            </Dropdown>
            <Dropdown item text='Reportes' style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }} >
                <Dropdown.Menu>

                    <Dropdown item icon='bell' text='Listados Generales' style={{ color: "#000" }}>
                        <Dropdown.Menu>
                            <Dropdown.Item icon='edit' text='Listado General Articulos' as={Link}
                                to="#" />
                            <Dropdown.Item icon='edit' text='Listado General de Proveedores' as={Link}
                                to="#" />
                            <Dropdown.Item icon='edit' text='Listado Proveedores Activos por Periodos' as={Link}
                                to="#" />
                            <Dropdown item icon='bell' text='Supervisor' style={{ color: "#000" }}>
                                <Dropdown.Menu>
                                    <Dropdown.Item icon='edit' text='Listado General de Ordenes de Compras y Servicios' as={Link}
                                        to="#" />
                                    <Dropdown.Item icon='edit' text='Ordenes de Compra por Proveedor' as={Link}
                                        to="#" />
                                    <Dropdown.Item icon='edit' text='Disponibilidad Presupuestaria' as={Link}
                                        to="#" />
                                </Dropdown.Menu>
                            </Dropdown>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown item icon='bell' text='Solicitudes' style={{ color: "#000" }}>
                        <Dropdown.Menu>
                            <Dropdown.Item icon='edit' text='Listado Solicitudes de Requisiciones' as={Link}
                                to="#" />
                            <Dropdown.Item icon='edit' text='Listado Solicitudes de Compras' as={Link}
                                to="#" />
                        </Dropdown.Menu>
                    </Dropdown>
                </Dropdown.Menu>
            </Dropdown>
            <Dropdown item text='Configuración' style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                <Dropdown.Menu>
                    <Dropdown.Item icon='user' text='Usuarios'
                        as={Link}
                        to="#"
                        style={{ color: "#fff" }}
                    />
                </Dropdown.Menu>
            </Dropdown>
            <Menu.Menu position='right'>
                
                <Menu.Item
                    name='volver'
                    active={activeItem === 'volver'}
                    onClick={handleItemClick}
                    as={Link}
                    to="/inicio"
                    style={{ color: "#fff" }}

                ><i className="fas fa-arrow-circle-left"> volver</i></Menu.Item>
            </Menu.Menu>
        </Menu> 
    ) */


    return menu;

} export default MenuComprasyAlmacen;